<div class="form-input">
  <label>{{ label| translate }} <span *ngIf="control?.invalid">*</span></label>

  <mat-form-field>
    <input matInput [disabled]="manual"
           [matDatepicker]="picker"
           [type]="type"
           [name]="name"
           (blur)="onTouched()"
           [(ngModel)]="value"
           [required]="required"
           [pattern]="pattern"
           [id]="name"
           [placeholder]="placeholder | translate"/>
    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
  </mat-form-field>

  <mat-datepicker touchUi #picker disabled="false"></mat-datepicker>
</div>
